import React from 'react';
import {Profile} from '../../components/profile/Profile';
import {useDocumentTitle} from '../../hooks/useDocumentTitle';

export const ProfilePage: React.FC = () => {
    useDocumentTitle('Profile');
    return <Profile/>;
};
